(function () {
  var formSelector = '.js-laseman-contact-form';
  var fieldNames = ['name', 'email', 'phone', 'theme', 'message', 'website'];
  var fallbackMessages = {
    success: 'Your message has been sent.',
    error: 'Unable to send your message. Please try again.',
    validation: 'Please correct the highlighted fields.'
  };
  var fallbackFieldMessages = {
    name: 'Please enter your name.',
    email: 'Please enter a valid email address.',
    phone: 'Please enter your phone number.'
  };
  var fieldLimits = {
    name: 120,
    email: 254,
    phone: 80,
    theme: 160,
    message: 4000
  };

  function getMessage(type) {
    var theme = window.lasemanTheme || {};
    var messages = theme.messages || {};

    return typeof messages[type] === 'string' && messages[type] ? messages[type] : (fallbackMessages[type] || fallbackMessages.error);
  }

  function getFieldMessage(fieldName) {
    var theme = window.lasemanTheme || {};
    var fieldMessages = theme.fieldMessages || {};

    return typeof fieldMessages[fieldName] === 'string' && fieldMessages[fieldName] ? fieldMessages[fieldName] : fallbackFieldMessages[fieldName];
  }

  function clearMessageTimer(message) {
    if (message && message._lasemanHideTimer) {
      window.clearTimeout(message._lasemanHideTimer);
      message._lasemanHideTimer = null;
    }
  }

  function clearErrors(form) {
    form.querySelectorAll('[data-field-error]').forEach(function (error) {
      error.textContent = '';
      error.hidden = true;
    });

    form.querySelectorAll('[aria-invalid="true"], .is-invalid').forEach(function (field) {
      field.removeAttribute('aria-invalid');
      field.classList.remove('is-invalid');
    });

    form.querySelectorAll('.laseman-form-message').forEach(function (message) {
      clearMessageTimer(message);
      message.textContent = '';
      message.hidden = true;
    });
  }

  function showMessage(form, type, message) {
    var target = form.querySelector('[data-form-message="' + type + '"]');

    if (!target) {
      target = form.querySelector('.laseman-form-message');
    }

    if (target) {
      clearMessageTimer(target);
      target.textContent = message;
      target.hidden = false;

      if ('success' === type) {
        target._lasemanHideTimer = window.setTimeout(function () {
          target.textContent = '';
          target.hidden = true;
          target._lasemanHideTimer = null;
        }, 5000);
      }
    }
  }

  function isFieldValid(field) {
    var value;

    if (!field || typeof field.value !== 'string') {
      return false;
    }

    value = field.value.trim();

    if (['name', 'email', 'phone'].indexOf(field.name) !== -1 && !value) {
      return false;
    }

    if ('email' === field.name && value && field.validity && !field.validity.valid) {
      return false;
    }

    return !fieldLimits[field.name] || value.length <= fieldLimits[field.name];
  }

  function hideErrorMessageIfResolved(form) {
    var errorMessage = form.querySelector('[data-form-message="error"]');

    if (!form.querySelector('[aria-invalid="true"]') && errorMessage) {
      errorMessage.textContent = '';
      errorMessage.hidden = true;
    }
  }

  function clearFieldError(form, fieldName) {
    var error = form.querySelector('[data-field-error="' + fieldName + '"]');
    var field = form.elements[fieldName];

    if (error) {
      error.textContent = '';
      error.hidden = true;
    }

    if (field) {
      field.removeAttribute('aria-invalid');
      field.classList.remove('is-invalid');
    }

    hideErrorMessageIfResolved(form);
  }

  function handleFieldInput(event) {
    var field = event.target;

    if (field && field.name && isFieldValid(field)) {
      clearFieldError(event.currentTarget, field.name);
    }
  }

  function showFieldError(form, fieldName, message) {
    var error = form.querySelector('[data-field-error="' + fieldName + '"]');
    var field = form.elements[fieldName];

    if (error) {
      error.textContent = message;
      error.hidden = false;
    }

    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.classList.add('is-invalid');
    }

    return field || null;
  }

  function renderFieldErrors(form, data) {
    var errors = data && (data.errors || data.field_errors || data.fieldErrors);
    var firstInvalidField = null;

    if (!errors || typeof errors !== 'object') {
      return firstInvalidField;
    }

    Object.keys(errors).forEach(function (fieldName) {
      var error = errors[fieldName];
      var message = Array.isArray(error) ? error[0] : error;

      if (typeof message === 'string' && message) {
        var field = showFieldError(form, fieldName, message);

        if (!firstInvalidField && field) {
          firstInvalidField = field;
        }
      }
    });

    return firstInvalidField;
  }

  function validateRequiredFields(form) {
    var firstInvalidField = null;

    ['name', 'email', 'phone'].forEach(function (fieldName) {
      var field = form.elements[fieldName];
      var value = field && typeof field.value === 'string' ? field.value.trim() : '';
      var invalid = !value;

      if ('email' === fieldName && value && field.validity && !field.validity.valid) {
        invalid = true;
      }

      if (invalid) {
        var invalidField = showFieldError(form, fieldName, getFieldMessage(fieldName));

        if (!firstInvalidField && invalidField) {
          firstInvalidField = invalidField;
        }
      }
    });

    if (firstInvalidField) {
      showMessage(form, 'error', getMessage('validation'));
      firstInvalidField.focus();
      return false;
    }

    return true;
  }

  function getServerMessage(payload) {
    var data = payload && payload.data;

    if (data && typeof data.message === 'string' && data.message) {
      return data.message;
    }

    return getMessage('error');
  }

  function submitForm(event) {
    var form = event.currentTarget;
    var submitButton = form.querySelector('#laseman-contact-submit');
    var theme = window.lasemanTheme || {};
    var hasAjaxConfig = theme.ajaxUrl && theme.nonce;
    var requestData;
    var request = Promise.resolve();

    event.preventDefault();
    clearErrors(form);

    if (!validateRequiredFields(form)) {
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
    }

    if (hasAjaxConfig) {
      requestData = new FormData(form);
      requestData.set('action', 'laseman_contact');
      requestData.set('nonce', theme.nonce);

      fieldNames.forEach(function (fieldName) {
        if (!requestData.has(fieldName)) {
          requestData.set(fieldName, '');
        }
      });

      request = fetch(theme.ajaxUrl, {
        method: 'POST',
        body: requestData,
        credentials: 'same-origin'
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('request_failed');
        }

        return response.json();
      });
    }

    request
      .then(function (payload) {
        if (!hasAjaxConfig) {
          showMessage(form, 'error', getMessage('error'));
          return;
        }

        if (!payload || payload.success !== true) {
          var firstInvalidField = renderFieldErrors(form, payload && payload.data);
          showMessage(form, 'error', getServerMessage(payload));

          if (firstInvalidField) {
            firstInvalidField.focus();
          }

          return;
        }

        form.reset();
        showMessage(form, 'success', getMessage('success'));
      })
      .catch(function () {
        showMessage(form, 'error', getMessage('error'));
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
        }
      });
  }

  function initializeContactForms() {
    document.querySelectorAll(formSelector).forEach(function (form) {
      if (form.dataset.lasemanContactBound === 'true') {
        return;
      }

      form.dataset.lasemanContactBound = 'true';
      form.addEventListener('input', handleFieldInput);
      form.addEventListener('change', handleFieldInput);
      form.addEventListener('submit', submitForm);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeContactForms);
  } else {
    initializeContactForms();
  }
}());
